<form class="wizard-panel operations" [formGroup]="form" (ngSubmit)="submit()">
  <div class="wizard-intro">
    <h2>Validate Your Operations</h2>
    <p>
      Confirm your receipts, employees and payroll, answer the operations questions, provide your
      subcontractor and payroll figures, then describe the work you perform.
    </p>
  </div>

  <div class="description">
    <div class="wizard-intro">
      <h4>Description of Operations</h4>
      <p>
        Please provide a detailed description of your operations. This includes the type of work you
        are currently engaged in or intend to engage in over the policy period.
      </p>
    </div>
    <lib-form-text-area
      formControlName="descriptionOfOperations"
      placeholder="Describe your operations"
      [rows]="3"
      maxlength="1000"
      [hideRequiredMarker]="true"
    />
  </div>

  <div class="figures">
    <div class="figure-table">
      <div class="figure-row heading">
        <h5>Type of Work</h5>
        <h5>{{ legacy() ? 'Total Payroll' : 'Percentage of Work' }}</h5>
      </div>
      @for (work of answers().typeOfWorkPercentages; track work.typeOfWork) {
        <div class="figure-row">
          <p>{{ work.typeOfWork }}</p>
          <p>
            {{ legacy() ? (work.payroll | currency: 'USD' : 'symbol' : '1.0-0') : percentText(work.percentage) }}
          </p>
        </div>
      }
    </div>

    <div class="figure-table estimates">
      <div class="figure-row">
        <p>Estimated Annual Gross Receipts</p>
        <p>{{ answers().grossReceipts | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
      </div>
      <div class="figure-row">
        <p>{{ payrollLabel() }}</p>
        <p>{{ answers().annualPayroll | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
      </div>
      <div class="figure-row">
        <p>Estimated Annual Subcontractor Costs</p>
        <p>{{ answers().subcontractedCosts | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
      </div>
      @if (!legacy()) {
        <div class="figure-row">
          <p>Owners Active in the Field</p>
          <p>{{ answers().numberOfOwnersInField }}</p>
        </div>
      }
      <div class="figure-row">
        <p>Number of Employees</p>
        <p>{{ answers().numberOfEmployees }}</p>
      </div>
    </div>

    <lib-form-dropdown
      label="Do you perform any new construction work on Condo’s, Townhomes, Apartments, or any other multi-unit residential projects?"
      formControlName="performNewConstruction"
      [options]="yesNoOptions"
      [hideRequiredMarker]="true"
    />
    <lib-form-dropdown
      label="Do you ever use casual labor/day labor that are not your W-2 employees?"
      formControlName="usesDayLabor"
      [options]="yesNoOptions"
      [hideRequiredMarker]="true"
    />
  </div>
</form>

<div class="wizard-footer">
  <lib-buttons cssType="btn-primary-outline" size="small" text="← Back" (click)="back.emit()" />
  <lib-buttons size="small" text="Next →" (click)="submit()" />
</div>
